import template from './opportunityDisplayBox.html';
import controller from './opportunityDisplayBox.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    staffUser: '<',
    opportunity: '=',
  }
};

export default component;
